export const EDITOR_ID = 'ng-wig-editable';
